import api from "!../../../../../../releases/f54ee87c18938cb09b51c05c8371d44f0f2f7b32/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../releases/f54ee87c18938cb09b51c05c8371d44f0f2f7b32/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[1]!../../../../../../releases/f54ee87c18938cb09b51c05c8371d44f0f2f7b32/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[2]!../../../../../../releases/f54ee87c18938cb09b51c05c8371d44f0f2f7b32/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[3]!./admin.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};